import {
  BrandedConfig,
  ENV_BRAND_NWB,
  ENV_BRAND_RBS,
  ENV_BRAND_UBN,
} from "services/envService";

export const LOAN_BALANCE_QUESTION = `What is the current balance of your Bounce Back Loan?`;
export const SORT_CODE_QUESTION = `Sort Code`;
export const ACCOUNT_NUMBER_QUESTION = `Main account number`;
export const ACCOUNT_NUMBER_TOOLTIP_MSG = `This means the amount left on your Bounce Back Loan`;
export const REPAYMENT_DATE_QUESTION = `Date of your final repayment?`;
export const REPAYMENT_DATE_TOOLTIP_MSG = `If this is your first PAYG application then the date of final repayment will be 6 years after you first received your Bounce Back Loan. Otherwise, the final repayment date can be found on your most recent PAYG documentation`;
export const TREATMENT_TAKEN_RADIO_QUESTION = `Have you already taken a Pay as you Grow (PAYG) option?`;
export const TREATMENT_OPTION_QUESTION = `Which PAYG option did you select?`;
export const EXTEND_TERM_CHECKBOX_QUESTION = `Extend the term of the loan to 10 years`;
export const REPAYMENT_TERM_RADIO_QUESTION = `For this repayment holiday, did you choose to extend the term of your loan by 6 months?`;
export const REPAYMENT_TERM_RADIO_OPTION1 = `No, I chose not to extend the term`;
export const REPAYMENT_TERM_RADIO_OPTION2 = `Yes, I chose to extend the term by 6 months`;
export const ALL_TREATEMENTS_TAKEN_WARNING_TEXT1 = ` You have told us that you have taken three Capital repayment holidays, one Capital & Interest repayment holiday and one Loan term extension to 10 years. There are no further PAYG options available to manage your Bounce Back Loan.`;
export const ALL_TREATEMENTS_TAKEN_WARNING_TEXT2_1 = `View information on all the support available to you`;
export const ALL_TREATEMENTS_TAKEN_WARNING_TEXT2_2 = `where you will also be able to chat with one of our specialist team members or contact your Relationship Manager if you have one.`;
export const ABOUT_YOUR_LOAN_NOTE = `Your loan details will be used to provide indicative figures for your selected loan treatment option. This may differ from the actual values in your legal documentation if the loan details entered differ from our records`;
export const TREATMENT_OPTIONS_CHECKBOX_1 = `Capital repayment holiday`;
export const TREATMENT_OPTIONS_CHECKBOX_2 = `Capital & Interest repayment holiday`;
export const TREATMENT_OPTIONS_CHECKBOX_3 = `Extend your original term to 10 years`;

export const REMAINING_BAL_2_DECIMAL_VALIDATION_ERROR_MSG = `Remaining amount to pay is either a whole number or set to two decimal places`;
export const REMAINING_BAL_MIN_MAX_DECIMAL_VALIDATION_ERROR_MSG = `The maximum remaining loan balance is £50,000`;

export const NO_OF_CRH_TAKEN = `How many capital repayment holidays have you taken?`;
export const NO_OF_CRH_TAKEN_ONE = `One`;
export const NO_OF_CRH_TAKEN_TWO = `Two`;
export const NO_OF_CRH_TAKEN_THREE = `Three`;

export const ONE_CRH_QUESTION = `For this repayment holiday, did you choose to extend the term of your loan by 6 months?`;
export const ONE_CRH_QUESTION_ANSWER_1 = `No, I chose not to extend the term`;
export const ONE_CRH_QUESTION_ANSWER_2 = `Yes, I chose to extend the term by 6 months`;
export const OTHER_CRH_QUESTION = `For these repayment holidays, did you choose to extend the term of your loan by 6 months?`;
export const OTHER_CRH_QUESTION_ANSWER_1 = `No`;
export const OTHER_CRH_QUESTION_ANSWER_2 = `Yes, for one holiday`;
export const TWO_CRH_QUESTION_ANSWER_3 = `Yes, for both holidays`;
export const THREE_CRH_QUESTION_ANSWER_3 = `Yes, for two holidays`;
export const THREE_CRH_QUESTION_ANSWER_4 = ` Yes, for all holidays`;

export const MAX_OPTION_TAKEN_LINK: BrandedConfig = {
  [ENV_BRAND_NWB]:
    "https://www.business.natwest.com/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg",
  [ENV_BRAND_RBS]:
    "https://www.business.rbs.co.uk/business/support-centre/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html#payg",
  [ENV_BRAND_UBN]:
    "https://digital.ulsterbank.co.uk/business/support/service-status/coronavirus/bounce-back-loan/bounce-back-loan-support.html",
};
